import { useNavigate } from "react-router-dom"
import { ClassCard } from "../components/ui/school/class-management/class-card"
import { classesData } from "../lib/classes-data"
import { SchoolSidebar } from "../components/ui/school/school-dashboard/school-sidebar"

const ClassManagementPage = () => {
  const navigate = useNavigate()

  const handleViewStudents = (classId) => {
    navigate(`/class-overview?class=${classId}`)
  }

  return (
    <div className="flex min-h-screen bg-gray-50">
      {/* School Sidebar */}
      <SchoolSidebar />

      {/* Main Content */}
      <main className="flex-1 lg:ml-64 p-4 md:p-8 overflow-y-auto">
        {/* Page Header */}
        <header className="mb-10">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
            <div>
              <h1 className="text-3xl font-extrabold mb-2">Class Management</h1>
              <p className="text-gray-500">Monitor academic progress and engagement across all classes.</p>
            </div>
            <div className="mt-4 md:mt-0 flex gap-4">
              <div className="flex items-center gap-2 bg-white px-4 py-2 rounded-lg shadow-sm border border-gray-100">
                <span className="w-2 h-2 rounded-full bg-green-500"></span>
                <span className="text-sm font-semibold text-gray-700">Term 2 - Active</span>
              </div>
            </div>
          </div>
        </header>

        {/* Class Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {classesData.map((classData) => (
            <ClassCard key={classData.id} classData={classData} onViewStudents={handleViewStudents} />
          ))}
        </div>
      </main>
    </div>
  )
}

export default ClassManagementPage